import React from 'react';

const HeatmapChartIcon = ({ size }: { size: number }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height="62"
      fill="none"
      viewBox="0 0 80 56"
    >
      <path
        fill="#BFDBFE"
        d="M22 8H12a2 2 0 0 0-2 2v7a2 2 0 0 0 2 2h10a2 2 0 0 0 2-2v-7a2 2 0 0 0-2-2"
      ></path>
      <path
        fill="#93C5FD"
        d="M38 8H28a2 2 0 0 0-2 2v7a2 2 0 0 0 2 2h10a2 2 0 0 0 2-2v-7a2 2 0 0 0-2-2"
      ></path>
      <path
        fill="#3B82F6"
        d="M54 8H44a2 2 0 0 0-2 2v7a2 2 0 0 0 2 2h10a2 2 0 0 0 2-2v-7a2 2 0 0 0-2-2"
      ></path>
      <path
        fill="#DBEAFE"
        d="M70 8H60a2 2 0 0 0-2 2v7a2 2 0 0 0 2 2h10a2 2 0 0 0 2-2v-7a2 2 0 0 0-2-2"
      ></path>
      <path
        fill="#60A5FA"
        d="M22 21H12a2 2 0 0 0-2 2v7a2 2 0 0 0 2 2h10a2 2 0 0 0 2-2v-7a2 2 0 0 0-2-2"
      ></path>
      <path
        fill="#93C5FD"
        d="M38 21H28a2 2 0 0 0-2 2v7a2 2 0 0 0 2 2h10a2 2 0 0 0 2-2v-7a2 2 0 0 0-2-2"
      ></path>
      <path
        fill="#EFF6FF"
        d="M54 21H44a2 2 0 0 0-2 2v7a2 2 0 0 0 2 2h10a2 2 0 0 0 2-2v-7a2 2 0 0 0-2-2"
      ></path>
      <path
        fill="#BFDBFE"
        d="M70 21H60a2 2 0 0 0-2 2v7a2 2 0 0 0 2 2h10a2 2 0 0 0 2-2v-7a2 2 0 0 0-2-2"
      ></path>
      <path
        fill="#60A5FA"
        d="M22 34H12a2 2 0 0 0-2 2v7a2 2 0 0 0 2 2h10a2 2 0 0 0 2-2v-7a2 2 0 0 0-2-2"
      ></path>
      <path
        fill="#93C5FD"
        d="M38 34H28a2 2 0 0 0-2 2v7a2 2 0 0 0 2 2h10a2 2 0 0 0 2-2v-7a2 2 0 0 0-2-2"
      ></path>
      <path
        fill="#3B82F6"
        d="M54 34H44a2 2 0 0 0-2 2v7a2 2 0 0 0 2 2h10a2 2 0 0 0 2-2v-7a2 2 0 0 0-2-2"
      ></path>
      <path
        fill="#1D4ED8"
        d="M70 34H60a2 2 0 0 0-2 2v7a2 2 0 0 0 2 2h10a2 2 0 0 0 2-2v-7a2 2 0 0 0-2-2"
      ></path>
    </svg>
  );
};

export default HeatmapChartIcon;
